

import React, { useState, useEffect } from 'react';
import emblem from '../asstes/emblem.svg';
import maharashtraLogo from '../asstes/Maharashtra.svg.png';
import sangliZPLogo from '../asstes/sanglizp.png';
import centerLogo from '../asstes/75.png';
import { useLanguage } from '../context/LanguageContext';

const WebsiteNavbar = () => {
  const { language, toggleLanguage } = useLanguage();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [menuTimeout, setMenuTimeout] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  // Maharashtra Government color scheme with gradients
  const colors = {
    primary: '#003366',
    secondary: '#FF9933',
    accent: '#138808',
    lightBlue: '#E6F0FF',
    cream: '#FFF5E6',
    white: '#FFFFFF',
    darkBlue: '#001A33',
    orange: '#FF8C1A',
    green: '#1A9A4A',
  };

  // Top bar gradient - White background
  const topBarGradient = {
    background: '#ffffff',
    borderBottom: '2px solid #e5e7eb',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
  };

  // Main navbar gradient - #ebe7e1 background
  const navbarGradient = {
    background: '#ebe7e1',
    boxShadow: '0 4px 20px rgba(0, 51, 102, 0.1)',
  };

  // Hover gradient for menu items
  const hoverGradient = {
    background: `linear-gradient(90deg, #fbac1b 0%, #f39c12 100%)`,
  };

  // Gram Panchayat information
  const gramPanchayatInfo = {
    name: { marathi: 'ग्रामपंचायत इनाम धामणी', english: 'Gram Panchayat Inam Dhamani' },
    taluka: { marathi: 'तालुका: मिरज', english: 'Taluka: Miraj' },
    district: { marathi: 'जिल्हा: सांगली', english: 'Dist: Sangli' },
  };

  // Menu data with all submenus
  const menuItems = [
    {
      id: 'home',
      marathi: 'मुख्यपृष्ठ',
      english: 'Home',
      submenu: [],
      link: '/'
    },
    {
      id: 'about',
      marathi: 'आमच्याविषयी',
      english: 'About Us',
      submenu: [
        { marathi: 'ग्रामपंचायत माहिती', english: 'Gram Panchayat Info', link: '/GramPanchayatInfo' },
        { marathi: 'इतिहास', english: 'History' },
        { marathi: 'ध्येय व उद्दिष्ट', english: 'Mission & Vision' },
        { marathi: 'ग्रामपंचायत MHUID चेक', english: 'Gram Panchayat MHUID Check' },
        { marathi: 'ग्रामपंचायत सदस्य', english: 'Gram Panchayat Members', link: '/GramPanchayatSamiti' },
      ]
    },
    {
      id: 'departments',
      marathi: 'विभाग',
      english: 'Departments',
      submenu: [
        { marathi: 'प्रशासन विभाग', english: 'Administration' },
        { marathi: 'पाणीपुरवठा विभाग', english: 'Water Supply' },
        { marathi: 'आरोग्य विभाग', english: 'Health' },
        { marathi: 'स्वच्छता विभाग', english: 'Sanitation' },
        { marathi: 'बांधकाम विभाग', english: 'Construction' },
      ]
    },
    {
      id: 'campaign',
      marathi: 'मुख्यमंत्री पंचायत राज अभियान',
      english: 'CM Panchayat Raj Campaign',
      submenu: [
        { marathi: 'सुशासनयुक्त पंचायत', english: 'Good Governance Panchayat' },
        { marathi: 'सक्षम पंचायत', english: 'Capable Panchayat' },
        { marathi: 'जलसमृद्ध स्वच्छ व हरित गाव', english: 'Water Rich, Clean & Green Village' },
        { marathi: 'गावपातळीवरील संस्था व सक्षमीकरण', english: 'Village Level Org & Empowerment' },
        { marathi: 'मनरेगा व इतर योजनेचा अभिसरण', english: 'MGNREGA Convergence' },
        { marathi: 'उपजीविका विकास सामाजिक न्याय', english: 'Livelihood Dev & Social Justice' },
        { marathi: 'लोकसहभाग व श्रमदान', english: 'Public Participation & Shramdan' }
      ]
    },
    {
      id: 'schemes',
      marathi: 'योजना',
      english: 'Schemes',
      submenu: [
        { marathi: 'ग्राम पंचायत योजना', english: 'Gram Panchayat Schemes', link: '/gram-panchayat-schemes' },
        { marathi: 'इतर विभाग योजना', english: 'Other Department Schemes', link: '/other-department-schemes' }
      ],
      link: '/schemes'
    },
    {
      id: 'notices',
      marathi: 'शासननिर्णय',
      english: 'Government Resolutions',
      submenu: [
        { marathi: 'अधिनियम (कायदे)', english: 'Acts (Laws)', link: '/adhiniyam' },
        { marathi: 'नियम', english: 'Rules', link: '/niyam' },
        { marathi: 'शासननिर्णय व परिपत्रके', english: 'Government Resolutions & Circulars', link: '/paripatrake' }
      ]
    },
    {
      id: 'mnrega',
      marathi: 'मनरेगा',
      english: 'MGNREGA',
      submenu: [],
      link: '/Mnrega'
    },
    {
      id: 'market',
      marathi: 'उमेद मार्केट',
      english: 'Local Market',
      submenu: [],
      link: '/Womengroup'
    },
    {
      id: 'services-menu',
      marathi: 'सेवा',
      english: 'Services',
      submenu: [
        { marathi: 'अर्जाची नमुने', english: 'Application Forms', link: '/forms' },
        { 
          marathi: 'स्वयं-घोषणापत्र', 
          english: 'Self Declaration', 
          link: '/self-declaration-dashboard', 
          subpoints: [
            { marathi: 'रहिवासी', english: 'Residential', link: '/residential' },
            { marathi: 'वीजजोडणी', english: 'Electricity', link: '/electricity' },
            { marathi: 'लाभ न घेतल्याचे', english: 'No Benefit', link: '/no-benefit' },
            { marathi: 'ह्यात', english: 'Alive', link: '/alive' },
            { marathi: 'शौचालय', english: 'Toilet', link: '/toilet' },
            { marathi: 'विधवा असल्याचे', english: 'Widow', link: '/widow' },
            { marathi: 'परित्यक्त्या', english: 'Deserted', link: '/self-declaration/parityaktya' },
            { marathi: 'अपत्य', english: 'Child', link: '/self-declaration/apatya' }
          ]
        }
      ]
    },
    {
      id: 'services',
      marathi: 'ऑनलाइन कर भरणा',
      english: 'Online Services',
      submenu: [
        { marathi: 'घरपट्टी भरणा', english: 'House Tax Payment', link: '/Housetax' },
        { marathi: 'पाणीपट्टी भरणा', english: 'Water Tax Payment', link: '/Paywatertax' },
      ]
    },
  ];

  // Extra section data
  const extraSections = [
    'ग्रामपंचायत कर्मचारी यादी',
    'महत्वाचे लिंक्स',
    'RTI माहिती',
    'वेबसाइट हिट काउंटर',
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLanguageChange = () => {
    toggleLanguage(language === 'marathi' ? 'english' : 'marathi');
  };

  const handleSearch = (e) => {
    e.preventDefault();
    console.log('Search submitted');
  };

  return (
    <div className="w-full font-sans print:hidden">
      {/* Header Section */}
      <div style={{ background: '#ffffff' }} className="text-gray-800 py-3 shadow-lg">
        <div className="max-w-10xl mx-auto px-4 md:px-8">
          <div className="flex items-center justify-between">
            {/* Left: Government Emblem and Titles */}
            <div className="flex items-center space-x-2 flex-shrink-0">
              <img
                src={emblem}
                alt="Government Emblem"
                className="w-16 h-16 object-contain"
              />
              <div className="hidden lg:flex flex-col items-start space-y-1">
                <h2 className="text-sm md:text-base font-bold text-black whitespace-nowrap"
                  style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.1)' }}>
                  {language === 'marathi' ? 'महाराष्ट्र शासन' : 'Government of Maharashtra'}
                </h2>

              </div>
            </div>

            {/* Center: Gram Panchayat Name */}
            <div className="text-center flex-1 mx-2 md:mx-8 lg:mx-12 flex items-center justify-center">
              <h2 className="text-lg md:text-xl lg:text-2xl font-bold mb-1 md:mb-2 lg:mb-3">
                {gramPanchayatInfo.name[language] || gramPanchayatInfo.name.marathi}
              </h2>
            </div>

            {/* Right: Logos and Titles */}
            <div className="flex items-center space-x-2 md:space-x-3 flex-shrink-0">
              <div className="text-right hidden xl:block">
                <h3 className="text-xs md:text-sm font-semibold text-gray-700 whitespace-nowrap">
                  {language === 'marathi' ? 'जिल्हा परिषद सांगली' : 'Zilla Parishad Sangli'}
                </h3>
                <h3 className="text-xs md:text-sm font-semibold text-gray-700 whitespace-nowrap">
                  {language === 'marathi' ? 'पंचायत समिती मिरज' : 'Panchayat Samiti Miraj'}
                </h3>
              </div>
              <img
                src={maharashtraLogo}
                alt="Maharashtra Logo"
                className="w-16 h-16 object-contain"
              />
              <img
                src={sangliZPLogo}
                alt="Sangli Zilla Parishad Logo"
                className="w-16 h-16 object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation Bar */}
      <nav
        className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'shadow-2xl' : 'shadow-lg'
          }`}
        style={navbarGradient}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {/* Navbar wrapper */}
          <div className="flex flex-col xl:flex-row xl:items-center w-full">
            {/* Mobile/Tablet Menu Button - Top section on small to large screens */}
            <div className="xl:hidden flex justify-between items-center w-full py-2">
              <span className="text-gray-800 font-bold text-lg px-2">{language === 'marathi' ? 'मेनू (Menu)' : 'Menu'}</span>
              <div className="flex items-center space-x-2">
                <button
                  onClick={handleLanguageChange}
                  className="px-2 py-1 rounded-lg bg-orange-500 text-white text-xs font-semibold hover:bg-orange-600 transition-colors shadow-sm whitespace-nowrap"
                >
                  {language === 'marathi' ? 'English' : 'मराठी'}
                </button>
                <button
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  className="p-2 rounded-lg text-gray-800 hover:bg-gray-200 transition-colors focus:outline-none"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {isMenuOpen ? (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    ) : (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                    )}
                  </svg>
                </button>
              </div>
            </div>

            {/* Desktop Menu Items */}
            <div className="hidden xl:flex items-center justify-between space-x-1 py-2 flex-1">
              {menuItems.map((item) => (
                <div
                  key={item.id}
                  className="relative group"
                  onMouseEnter={() => {
                    if (item.submenu.length > 0) {
                      if (menuTimeout) {
                        clearTimeout(menuTimeout);
                        setMenuTimeout(null);
                      }
                      setActiveMenu(item.id);
                    }
                  }}
                  onMouseLeave={() => {
                    if (item.submenu.length > 0) {
                      const timeout = setTimeout(() => {
                        setActiveMenu(null);
                        setMenuTimeout(null);
                      }, 200);
                      setMenuTimeout(timeout);
                    }
                  }}
                >
                  {item.submenu.length > 0 ? (
                    <button
                      className="px-1.5 py-1 text-sm text-gray-800 font-semibold rounded-lg transition-all duration-300 hover:bg-gray-200 group-hover:shadow-lg flex items-center space-x-0.5 whitespace-nowrap"
                    >
                      <span>{item[language] || item.marathi}</span>
                      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                  ) : (
                    <a
                      href={item.link || '#'}
                      className="px-1.5 py-1 text-sm text-gray-800 font-semibold rounded-lg transition-all duration-300 hover:bg-gray-200 group-hover:shadow-lg flex items-center space-x-0.5 whitespace-nowrap"
                    >
                      <span>{item[language] || item.marathi}</span>
                    </a>
                  )}

                  {/* Submenu Dropdown */}
                  {activeMenu === item.id && item.submenu.length > 0 && (
                    <div
                      className="absolute top-full left-0 mt-1 w-64 rounded-lg shadow-2xl border border-white/20 backdrop-blur-lg z-50"
                      style={{ background: 'rgba(255, 255, 255, 0.95)' }}
                      onMouseEnter={() => {
                        if (menuTimeout) {
                          clearTimeout(menuTimeout);
                          setMenuTimeout(null);
                        }
                      }}
                      onMouseLeave={() => {
                        const timeout = setTimeout(() => {
                          setActiveMenu(null);
                          setMenuTimeout(null);
                        }, 200);
                        setMenuTimeout(timeout);
                      }}
                    >
                      <div className="py-2">
                        <style>{`
                          .nested-menu-parent:hover .nested-menu-child {
                            display: block !important;
                            opacity: 1 !important;
                            visibility: visible !important;
                          }
                        `}</style>
                        {item.submenu.map((subItem, index) => (
                          <div key={index} className="relative nested-menu-parent">
                            <a
                              href={typeof subItem === 'object' ? subItem.link : '#'}
                              className="block px-4 py-3 text-gray-800 hover:text-white transition-all duration-300 hover:shadow-md flex justify-between items-center"
                              style={{
                                background: 'transparent',
                                transition: 'all 0.3s ease'
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = hoverGradient.background;
                                e.currentTarget.style.color = 'white';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = 'transparent';
                                e.currentTarget.style.color = '#374151';
                              }}
                            >
                              <div className="flex items-center space-x-2">
                                <span className="w-1 h-1 rounded-full bg-gray-400"></span>
                                <span className="text-sm">{subItem[language] || subItem.marathi}</span>
                              </div>
                              {subItem.subpoints && (
                                <svg className="w-4 h-4 transform -rotate-90 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                </svg>
                              )}
                            </a>

                            {/* Nested Submenu Child */}
                            {subItem.subpoints && (
                              <div
                                className="nested-menu-child absolute top-0 left-full ml-1 w-64 rounded-lg shadow-2xl overflow-hidden border border-white/20 backdrop-blur-lg hidden"
                                style={{ background: 'rgba(255, 255, 255, 0.95)' }}
                              >
                                <div className="py-2">
                                  {subItem.subpoints.map((nestedItem, nIndex) => (
                                    <a
                                      key={nIndex}
                                      href={nestedItem.link || '#'}
                                      className="block px-4 py-3 text-gray-800 hover:text-white transition-all duration-300"
                                      style={{
                                        background: 'transparent',
                                        transition: 'all 0.3s ease'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.background = hoverGradient.background;
                                        e.currentTarget.style.color = 'white';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.background = 'transparent';
                                        e.currentTarget.style.color = '#374151';
                                      }}
                                    >
                                      <div className="flex items-center space-x-2">
                                        <span className="w-1 h-1 rounded-full bg-gray-400"></span>
                                        <span className="text-sm">{nestedItem[language] || nestedItem.marathi}</span>
                                      </div>
                                    </a>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}

              <div className="ml-1 pl-1 border-l border-gray-300">
                <button
                  onClick={handleLanguageChange}
                  className="px-2 py-1 rounded-lg bg-orange-500 text-white text-xs font-semibold hover:bg-orange-600 transition-colors shadow-sm whitespace-nowrap"
                >
                  {language === 'marathi' ? 'English' : 'मराठी'}
                </button>
              </div>

              {/* Login Button */}
              <div className="ml-1 pl-1 border-l border-gray-300">
                <button
                  onClick={() => window.location.href = '/login'}
                  className="group relative px-3 py-1 rounded-lg bg-gradient-to-r from-blue-600 to-blue-700 text-white text-xs font-semibold transition-all duration-300 hover:shadow-xl hover:scale-105 hover:from-blue-700 hover:to-blue-800 border border-blue-500 whitespace-nowrap"
                >
                  <span className="relative z-10 flex items-center gap-2">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                    </svg>
                    <span>
                      {language === 'marathi' ? 'लॉगिन' : 'Login'}
                    </span>
                  </span>
                  <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                </button>
              </div>
            </div>

            {/* Mobile/Tablet Menu Dropdown */}
            <div className={`xl:hidden overflow-hidden transition-all duration-300 ease-in-out w-full ${isMenuOpen ? 'max-h-[80vh] overflow-y-auto opacity-100 py-4' : 'max-h-0 opacity-0 py-0'}`}>
              <div className="flex flex-col space-y-2 px-2">
                {menuItems.map((item) => (
                  <div key={item.id} className="flex flex-col">
                    <div
                      className="flex items-center justify-between text-gray-800 font-semibold py-2 px-3 rounded-lg hover:bg-gray-200 transition-colors cursor-pointer"
                      onClick={() => {
                        if (item.submenu.length > 0) {
                          setActiveMenu(activeMenu === item.id ? null : item.id);
                        } else if (item.link) {
                          window.location.href = item.link;
                          setIsMenuOpen(false);
                        }
                      }}
                    >
                      <span className="font-medium">{item[language] || item.marathi}</span>
                      {item.submenu.length > 0 && (
                        <svg className={`w-4 h-4 transition-transform duration-300 ${activeMenu === item.id ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      )}
                    </div>
                    {/* Mobile Submenu Dropdown */}
                    {item.submenu.length > 0 && activeMenu === item.id && (
                      <div className="pl-6 pr-2 py-2 flex flex-col space-y-1 bg-black/10 rounded-lg mt-1 border-l-2 border-[#fbac1b]">
                        {item.submenu.map((subItem, index) => (
                          <div key={index}>
                            <div
                              className="py-2 px-3 text-gray-700 hover:text-gray-900 hover:bg-gray-200 rounded-md text-sm transition-colors flex items-center justify-between cursor-pointer"
                              onClick={(e) => {
                                if (subItem.subpoints) {
                                  const el = document.getElementById(`mobile-subpoints-${index}`);
                                  if (el) el.classList.toggle('hidden');
                                } else {
                                  if (!subItem.link && typeof subItem !== 'object') e.preventDefault();
                                  setIsMenuOpen(false);
                                  if (subItem.link) window.location.href = subItem.link;
                                }
                              }}
                            >
                              <div className="flex items-center space-x-2">
                                <span className="w-1.5 h-1.5 rounded-full bg-[#fbac1b]"></span>
                                <span>{subItem[language] || subItem.marathi}</span>
                              </div>
                              {subItem.subpoints && (
                                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                </svg>
                              )}
                            </div>
                            
                            {/* Mobile Nested Subpoints */}
                            {subItem.subpoints && (
                              <div id={`mobile-subpoints-${index}`} className="hidden pl-6 pr-2 py-1 flex-col space-y-1 bg-black/5 rounded-lg mt-1 border-l-2 border-gray-400">
                                {subItem.subpoints.map((nestedItem, nIndex) => (
                                  <a
                                    key={nIndex}
                                    href={nestedItem.link || '#'}
                                    className="py-2 px-3 text-gray-700 hover:text-gray-900 hover:bg-gray-200 rounded-md text-sm transition-colors flex items-center space-x-2"
                                    onClick={() => setIsMenuOpen(false)}
                                  >
                                    <span className="w-1 h-1 rounded-full border border-gray-500"></span>
                                    <span>{nestedItem[language] || nestedItem.marathi}</span>
                                  </a>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}

                <div className="pt-4 pb-2 border-t border-gray-300 mt-2">
                  <button
                    onClick={() => window.location.href = '/login'}
                    className="w-full flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold shadow-lg"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                    </svg>
                    <span>{language === 'marathi' ? 'लॉगिन' : 'Login'}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* News Marquee */}
      <div className="w-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 text-gray-800 py-2 overflow-hidden shadow-lg">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center">
            <span className="bg-gradient-to-r from-gray-500 to-gray-600 text-white px-4 py-1.5 rounded-lg font-bold text-sm mr-4 shadow-md whitespace-nowrap">
              {language === 'marathi' ? 'ताज्या बातम्या' : 'Latest News'}
            </span>
            <div className="flex-1 overflow-hidden">
              <marquee className="text-sm font-medium" scrollamount="5">
                {language === 'marathi' 
                  ? '📢 इनाम धामणी ग्रामपंचायतेतर्फे नवीन विकास योजनांची घोषणा | 💧 पाणीपुरवठा योजनेला मंजुरी | 🏥 आरोग्य शिबिर आयोजित | 📚 विद्यार्थी शिष्यवृत्ती योजना सुरू | 🌳 वृक्षारोपण मोहिम सुरू | 🏗️ ग्रामविकास कामांना वेग | 🚰 स्वच्छ पाणी योजना | 🏘️ आवास योजना | 🛣️ रस्ते विकास काम | 👨‍🌾 शेतकरी मदत योजना | 💼 रोजगार हमी योजना'
                  : '📢 New Development Schemes Announced by Inam Dhamani Gram Panchayat | 💧 Water Supply Scheme Approved | 🏥 Health Camp Organized | 📚 Student Scholarship Scheme Started | 🌳 Tree Plantation Campaign Started | 🏗️ Rural Development Work Sped Up | 🚰 Clean Water Scheme | 🏘️ Housing Scheme | 🛣️ Road Development Work | 👨‍🌾 Farmer Help Scheme | 💼 Employment Guarantee Scheme'}
              </marquee>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebsiteNavbar;